import Input from './input.component';

export default Input;
